import React, { ReactElement, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { tagPathDisplaySelector } from '../../../../../element/tags/tagPathDisplaySelector';
import { closePopup } from '../../../../../components/popupPanel/popupActions';
import { getTagById } from '../../../../../element/tags/tagsService';

import ToolbarPopupTool from '../../ToolbarPopupTool';
import TagsToolbarPopup from './TagsToolbarPopup';

import { ImMNElement } from '../../../../../../common/elements/elementModelTypes';
import { PopupIds } from '../../../../../components/popupPanel/popupConstants';
import { Tag } from '../../../../../../common/tags/tagTypes';

export type TagsToolProps = {
    selectedElements: Immutable.List<ImMNElement>;
    name: string;
};

// Wrapper to prevent TS errors when passing spread props as a result of JS PropTypes definitions
const TagsToolbarPopupWrapper = (props: any) => {
    const [currentlyEditingTag, setCurrentlyEditingTag] = useState<Tag | null>(null);
    const [showEditingPopup, setShowEditingPopup] = useState<boolean>(false);
    const { shareRootPath } = useSelector(tagPathDisplaySelector);
    const dispatch = useDispatch();

    const handleClickEdit = async (tagId: string) => {
        if (!tagId) return;

        const tag = await getTagById(tagId);
        if (!tag) return;

        setCurrentlyEditingTag(tag);
        setShowEditingPopup(true);
    };

    const dismissPopup = () => {
        dispatch(closePopup(PopupIds.TAGS_TOOL));
        setShowEditingPopup(false);
        setCurrentlyEditingTag(null);
    };

    return (
        <TagsToolbarPopup
            {...props}
            tag={currentlyEditingTag}
            showEditingPopup={showEditingPopup}
            rootPath={shareRootPath}
            handleClickEdit={handleClickEdit}
            closePopup={dismissPopup}
        />
    );
};

const TagsTool = (props: TagsToolProps): ReactElement => {
    return (
        <ToolbarPopupTool
            {...props}
            popupId={PopupIds.TAGS_TOOL}
            toolName={'tag'}
            buttonSelector=".TagTool .icon"
            PopupComponent={TagsToolbarPopupWrapper}
        />
    );
};

export default TagsTool;
